// @ts-nocheck
import React, { FC } from "react";
import { Stack } from "@mui/material";
import { SsoButton, SsoButtonText } from "./Styled";
import { useLanguage } from "Utils/translations/lib";
interface SsoProvider {
  id: number;
  providerIcon: string;
  providerName: string;
  serverUrl: string;
  key: string;
}

interface SsoButtonGroupParameters {
  companySsoProviders?: Array<any>;
  // FLO-15513: at most one, since SAML is a single protocol-exclusive config per company (t1,
  // FLO-15510) rather than a plural provider list like companySsoProviders (OIDC).
  companySamlProvider?: {
    companyId: number;
    providerName: string;
    providerIcon?: string;
  } | null;
  type?: string;
}

export const SsoButtonGroup: FC<SsoButtonGroupParameters> = ({
  companySsoProviders,
  companySamlProvider,
  type = "login",
}) => {
  const { t } = useLanguage();

  return (
    <Stack id="sso-button-group">
      {companySsoProviders?.map((provider, i) => (
        <SsoButton
          key={`${i}-${provider}`}
          variant="outlined"
          sx={{ mb: "12px" }}
          size="large"
          href={`/oidc/${type}/${provider.key}`}
          disableRipple={true}
          startIcon={
            <img
              src={provider.providerIcon}
              alt={t("auth.ssoProviderLogoAlt", {
                provider: provider.providerName,
              })}
              style={{ width: 22, height: 22 }}
            />
          }
        >
          <SsoButtonText>
            {t("auth.continueWithProvider", {
              provider: provider.providerName,
            })}
          </SsoButtonText>
        </SsoButton>
      ))}
      {companySamlProvider && (
        <SsoButton
          key="saml"
          variant="outlined"
          sx={{ mb: "12px" }}
          size="large"
          href={`/saml/${type}/${companySamlProvider.companyId}`}
          disableRipple={true}
          startIcon={
            companySamlProvider.providerIcon ? (
              <img
                src={companySamlProvider.providerIcon}
                alt="company-logo"
                style={{ width: 22, height: 22 }}
              />
            ) : undefined
          }
        >
          <SsoButtonText>
            Continue with {companySamlProvider.providerName}
          </SsoButtonText>
        </SsoButton>
      )}
    </Stack>
  );
};
